module.exports = __webpack_public_path__ + "img/fishing_site_thumb.63723e8b.jpg";